import './index.css'
import cn from 'clsx'

import React from 'react'
import Switch from './index'
import SwitchLabel from './switch-label'
type Props = {
  children: React.ReactNode
  disabled?: boolean
}

const SwitchContainer = ({
  children,
  disabled,
}: Props): React.ReactNode | React.ReactElement<'div'> => (
  <div
    className={cn('switch-toggle--container', {
      'switch-toggle-container--disabled': disabled,
    })}
  >
    {children}
  </div>
)

SwitchContainer.SwitchLabel = SwitchLabel
SwitchContainer.Switch = Switch
export default SwitchContainer
